var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.452 11.5954H7.27928V21.1281H10.452V11.5954Z",
    fill: "#03045E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88661 7C9.97197 7 10.6404 7.7119 10.661 8.64657C10.661 9.56188 9.97197 10.2943 8.8657 10.2943H8.84543C7.78028 10.2943 7.09167 9.56188 7.09167 8.64657C7.09167 7.7119 7.80125 7 8.88661 7Z",
    fill: "#03045E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.894 15.6623C21.894 12.7343 20.3288 11.3716 18.241 11.3716C16.5565 11.3716 15.8023 12.2968 15.3812 12.9459V11.5957H12.2081C12.25 12.4902 12.2081 21.1283 12.2081 21.1283H15.3812V15.8045C15.3812 15.5196 15.4018 15.2354 15.4857 15.0314C15.715 14.4623 16.2371 13.873 17.1136 13.873C18.2622 13.873 18.7213 14.7471 18.7213 16.0281V21.1281H21.8939L21.894 15.6623Z",
    fill: "#03045E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 27C21.6797 27 27.5 21.1797 27.5 14C27.5 6.8203 21.6797 1 14.5 1C7.3203 1 1.5 6.8203 1.5 14C1.5 21.1797 7.3203 27 14.5 27ZM14.5 28C22.232 28 28.5 21.732 28.5 14C28.5 6.26801 22.232 0 14.5 0C6.76801 0 0.5 6.26801 0.5 14C0.5 21.732 6.76801 28 14.5 28Z",
    fill: "#03045E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6a59cde61b880ae89199944ee33105ac.svg";
export { ForwardRef as ReactComponent };